module.exports = __webpack_public_path__ + "static/img/news_program_1.26ce83b7.jpg";